//this model is used to define the are of business of the lab
export class BusinessArea{
    _id: string;
    /** The business Area where the concerned lab is located. */
    name:string;

	/** stores if the boolean value is active or not */
    active:boolean;
}